import { createMuiTheme } from '@material-ui/core/styles'
import { defaultTheme } from '@heeros/react-sdk'
import '@heeros/react-sdk/dist/styles/core.css'
import '@heeros/react-sdk/dist/styles/circular-std.css'

export default createMuiTheme(defaultTheme)
